import * as colorUtils from '../utils/color';

export function setPageBackgroundColor(pages, hexColor) {
  return pages.map((p) =>
    p
      .setIn(['background', 'color'], colorUtils.hexToDecimal(hexColor))
      .deleteIn(['background', 'graphicItem']),
  );
}

export function setPageBackgroundImage(pages, imageID) {
  return pages.map((p) =>
    p
      .setIn(['background', 'graphicItem'], imageID)
      .deleteIn(['background', 'color']),
  );
}

export function getSelectedColor(pages) {
  let selectedPage = pages.valueSeq().toJS()[0];
  let selectedColor;

  if (
    selectedPage &&
    selectedPage.background &&
    selectedPage.background.color !== undefined
  ) {
    selectedColor = colorUtils.DecimalToHex(selectedPage.background.color);
  }

  if (selectedColor === undefined) {
    selectedColor = '#ffffff';
  }

  return selectedColor;
}
